var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#7A44DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.8122C6.55681 12.6916 6.65004 12.6036 6.7469 12.5163C7.06689 12.2279 7.38347 11.9357 7.70223 11.6455C7.9285 11.4394 8.11933 11.4456 8.33516 11.6685C9.14458 12.5045 9.95303 13.3415 10.762 14.178C10.9894 14.4132 11.1868 14.414 11.4175 14.1808C13.306 12.272 15.1944 10.363 17.0824 8.45399C17.3233 8.21065 17.5151 8.21163 17.7571 8.45892C18.0846 8.79323 18.4119 9.1273 18.7391 9.46187C18.9642 9.69189 18.9657 9.90664 18.7428 10.1327C16.3029 12.6061 13.8627 15.0794 11.4223 17.5525C11.1907 17.7872 10.9892 17.784 10.7561 17.5501C9.35337 16.1393 8.00037 14.6793 6.63668 13.2301C6.5806 13.1704 6.54928 13.0962 6.5 13.0336V12.8122Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.4091,
    height: 9.45455,
    fill: "white",
    transform: "translate(6.5 8.27271)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.67d44e7f9bb8479223e308e8b40b6e64.svg";
export { ForwardRef as ReactComponent };